/* eslint-disable react/prop-types */
import { Component } from "react"
import _ from "underscore"
import FormForm from "./form_form"
import { Box } from "components/ui"

const attendeesToVisibleIds = (visibleToAttendeeTypes = {}) => {
  return visibleToAttendeeTypes.reduce((visibleToAttendeeTypeIds, at) => {
    if (at.visible) {
      visibleToAttendeeTypeIds[at.id] = true
    }
    return visibleToAttendeeTypeIds
  }, {})
}

const addOnsToVisibleIds = (visibleToAddOns = {}) => {
  return visibleToAddOns.reduce((visibleToAddOnIds, ao) => {
    if (ao.visible) {
      visibleToAddOnIds[ao.id] = true
    }
    return visibleToAddOnIds
  }, {})
}

class FormEdit extends Component {
  constructor(props) {
    super(props)

    const {
      form: { hasRestrictionsOnAttendeeTypes, hasRestrictionsOnAddOns, addOns, attendeeTypes }
    } = props

    this.state = {
      hasRestrictionsOnAttendeeTypes,
      hasRestrictionsOnAddOns,
      visibleToAttendeeTypeIds: attendeesToVisibleIds(attendeeTypes),
      visibleToAddOnIds: addOnsToVisibleIds(addOns)
    }

    this.handleCancelClick = this.handleCancelClick.bind(this)
    this.handleSubmitClick = this.handleSubmitClick.bind(this)
    this.handleAttendeeTypeLimitClick = this.handleAttendeeTypeLimitClick.bind(this)
    this.handleAddOnLimitClick = this.handleAddOnLimitClick.bind(this)
    this.handleVisibleToAttendeeTypesChange = this.handleVisibleToAttendeeTypesChange.bind(this)
    this.handleVisibleToAddOnsChange = this.handleVisibleToAddOnsChange.bind(this)
    this.handleDeleteClick = this.handleDeleteClick.bind(this)
  }

  handleDeleteClick() {
    const { form: { id } = {} } = this.props
    alertModal(
      {
        title: "Delete this form?",
        text: "This can't be undone.",
        type: "warning",
        showCancelButton: true,
        cancelButtonText: "No, don't delete it",
        confirmButtonText: "Yes, delete the form.",
        customClass: "destructive-warning",
        closeOnConfirm: true
      },
      () => {
        return $.ajax({
          method: "DELETE",
          headers: { "X-CSRF-Token": $.rails.csrfToken() },
          url: `/forms/${id}`
        })
      }
    )
  }

  handleCancelClick() {
    const { event: { id } = {} } = this.props
    Turbolinks.visit(`/signups/${id}/forms`)
  }

  handleSubmitClick() {
    const { form: { id } = {}, event: { id: eventId } = {} } = this.props

    App.Modal.loadingModal("")

    const data = this.buildFormData()

    fetch(`/forms/${id}`, {
      method: "PUT",
      headers: {
        "X-CSRF-Token": $.rails.csrfToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      credentials: "include",
      body: JSON.stringify(data)
    })
      .then(resp => resp.json())
      .then(resp => {
        if (resp.errors) {
          alertModal({
            title: "An error occured",
            text: resp.errors,
            type: "error",
            confirmButtonText: "Ok",
            closeOnConfirm: true
          })
          Bugsnag.notifyException(resp, "FormPostError")
        } else {
          Turbolinks.visit(`/signups/${eventId}/forms/`, { action: "replace" })
        }
      })
      .catch(resp => {
        Bugsnag.notifyException(resp, "FormPostError")
        alertModal({
          title: "An error occured",
          text: resp.errors,
          type: "error",
          confirmButtonText: "Ok",
          closeOnConfirm: true
        })
      })
      .finally(() => {
        App.Modal.hide()
      })
  }

  handleAttendeeTypeLimitClick() {
    let { form: { attendeeTypes } = {} } = this.props

    attendeeTypes = _.map(attendeeTypes, at => {
      at.visible = true
      return at
    })

    this.setState(prevState => ({
      hasRestrictionsOnAttendeeTypes: !prevState.hasRestrictionsOnAttendeeTypes,
      visibleToAttendeeTypeIds: attendeesToVisibleIds(attendeeTypes)
    }))
  }

  handleAddOnLimitClick() {
    let { form: { addOns } = {} } = this.props

    addOns = _.map(addOns, ao => {
      ao.visible = true
      return ao
    })

    this.setState(prevState => ({
      hasRestrictionsOnAddOns: !prevState.hasRestrictionsOnAddOns,
      visibleToAddOnIds: addOnsToVisibleIds(addOns)
    }))
  }

  handleVisibleToAttendeeTypesChange(atId) {
    this.setState(prevState => ({
      visibleToAttendeeTypeIds: {
        ...prevState.visibleToAttendeeTypeIds,
        [atId]: !prevState.visibleToAttendeeTypeIds[atId]
      }
    }))
  }

  handleVisibleToAddOnsChange(aoId) {
    this.setState(prevState => ({
      visibleToAddOnIds: {
        ...prevState.visibleToAddOnIds,
        [aoId]: !prevState.visibleToAddOnIds[aoId]
      }
    }))
  }

  render() {
    const {
      event,
      form: { attachment, name, remoteURL, active, externalForm }
    } = this.props

    const {
      hasRestrictionsOnAttendeeTypes,
      hasRestrictionsOnAddOns,
      visibleToAttendeeTypeIds,
      visibleToAddOnIds
    } = this.state

    let theFormType = ""

    if (remoteURL && !externalForm) {
      theFormType = "people"
    } else if (remoteURL && externalForm) {
      theFormType = "url"
    } else {
      theFormType = "pdf"
    }

    const form = {
      active,
      attachment,
      formType: theFormType,
      hasRestrictionsOnAddOns,
      hasRestrictionsOnAttendeeTypes,
      name,
      remoteURL,
      visibleToAddOnIds,
      visibleToAttendeeTypeIds
    }

    return (
      <section>
        <FormForm
          event={event}
          form={form}
          editMode={true}
          onAttendeeTypeLimitClick={this.handleAttendeeTypeLimitClick}
          onVisibleToAttendeeTypesChange={this.handleVisibleToAttendeeTypesChange}
          onAddOnLimitClick={this.handleAddOnLimitClick}
          onVisibleToAddOnsChange={this.handleVisibleToAddOnsChange}
          onDeleteClick={this.handleDeleteClick}
          onSubmitClick={this.handleSubmitClick}
          onCancelClick={this.handleCancelClick}
          isValid={true}
        />
      </section>
    )
  }

  buildFormData() {
    const {
      hasRestrictionsOnAddOns,
      hasRestrictionsOnAttendeeTypes,
      visibleToAttendeeTypeIds,
      visibleToAddOnIds
    } = this.state

    let data = {}
    let form = {}

    if (hasRestrictionsOnAttendeeTypes) {
      form["visible_to_attendee_type_ids"] = Object.keys(visibleToAttendeeTypeIds)
        .filter(atid => {
          if (visibleToAttendeeTypeIds[atid]) {
            return Number(atid)
          }
        })
        .join()
      data["attendee_type_limit_forms"] = "1"
    } else {
      data["attendee_type_limit_forms"] = "0"
    }

    if (hasRestrictionsOnAddOns) {
      form["visible_to_add_on_ids"] = Object.keys(visibleToAddOnIds)
        .filter(aoid => {
          if (visibleToAddOnIds[aoid]) {
            return aoid
          }
        })
        .join()
      data["add_on_limit_forms"] = "1"
    } else {
      data["add_on_limit_forms"] = "0"
    }

    data.form = form
    return data
  }
}

export default FormEdit
